const { labPath } = require('./labs');
const SITE = 'https://esf.gold';
const publicPages = [
  { path: '/', title: 'ESF Gold | خرید و فروش طلا و فهرست آزمایشگاه‌های ری‌گیری', description: 'خدمات آنلاین ESF Gold و دسترسی به فهرست نام و شماره تماس آزمایشگاه‌های ری‌گیری طلا.' },
  { path: '/labs-page', title: 'نام و تلفن آزمایشگاه‌های ری‌گیری طلا در ایران | ESF Gold', description: 'جست‌وجوی نام آزمایشگاه‌های ری‌گیری طلا و مشاهده شماره‌های تماس ثبت‌شده؛ هر نام دارای صفحه اطلاعات تماس مستقل است.' },
  { path: '/about_page', title: 'درباره ESF Gold', description: 'آشنایی با ESF Gold و خدمات سایت.' },
  { path: '/Contact', title: 'تماس با ESF Gold', description: 'اطلاعات تماس و راه‌های ارتباط با ESF Gold.' },
  { path: '/tutorial', title: 'راهنمای استفاده از ESF Gold', description: 'راهنمای ثبت‌نام و استفاده از امکانات ESF Gold.' },
  { path: '/FAQ', title: 'پرسش‌های متداول ESF Gold', description: 'پاسخ پرسش‌های متداول درباره ثبت‌نام و خدمات ESF Gold.' },
];
function decodePath(value) { try { return decodeURIComponent(value).replace(/\/+$/, '') || '/'; } catch { return '/invalid-path'; } }
function pageSeo(pathname, labs) {
  const path = decodePath(pathname);
  if (path === '/install') return { path, title: 'نصب برنامه ESF Gold | راهنمای اندروید و آیفون', description: 'راهنمای افزودن ESF Gold به صفحه اصلی گوشی و نصب از مرورگر.', robots: 'noindex,follow' };
  if (path === '/version-info') return { path, title: 'مرکز به‌روزرسانی ESF Gold', description: 'بررسی نسخه تازه سایت و مشاهده اطلاعات نسخه فعال.', robots: 'noindex,follow' };
  const page = publicPages.find(item => item.path.toLowerCase() === path.toLowerCase());
  if (page) return Object.assign({}, page, { canonical: SITE + page.path, robots: 'index,follow' });
  const lab = labs.find(item => labPath(item) === path);
  if (lab) return {
    path, title: `${lab.name} | شماره تماس آزمایشگاه ری‌گیری طلا | ESF Gold`,
    description: `اطلاعات تماس «${lab.name}» در فهرست آزمایشگاه‌های ری‌گیری طلا: ${lab.records[0].phones.map(phone => phone.display).join('، ')}. شماره‌ها از فهرست سایت هستند؛ پیش از مراجعه استعلام کنید.`,
    canonical: SITE + path, robots: 'index,follow', lab,
  };
  return { path, title: 'ESF Gold', description: 'پنل کاربری ESF Gold', robots: 'noindex,follow' };
}
function structuredData(seo, labs) {
  if (seo.path === '/labs-page') return { '@context': 'https://schema.org', '@type': 'CollectionPage', name: seo.title, url: seo.canonical, mainEntity: {
    '@type': 'ItemList', numberOfItems: labs.length, itemListElement: labs.map((lab, index) => ({ '@type': 'ListItem', position: index + 1, name: lab.name, url: SITE + labPath(lab) })),
  } };
  if (seo.lab) return { '@context': 'https://schema.org', '@graph': [
    { '@type': 'WebPage', name: seo.title, description: seo.description, url: seo.canonical, inLanguage: 'fa-IR' },
    { '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ESF Gold', item: SITE + '/' },
      { '@type': 'ListItem', position: 2, name: 'آزمایشگاه‌های ری‌گیری طلا', item: SITE + '/labs-page' },
      { '@type': 'ListItem', position: 3, name: seo.lab.name, item: seo.canonical },
    ] },
  ] };
  if (seo.path === '/') return { '@context': 'https://schema.org', '@type': 'Organization', name: 'ESF Gold', url: SITE };
  return null;
}
module.exports = { SITE, publicPages, pageSeo, structuredData, decodePath };
